<template>
  <div>
    <div class="my-2.5 text-xl font-bold px-5 lg:px-0">
      {{ $t('lots.id.restOwners') }}
    </div>
    <div class="relative flex flex-row items-center">
      <ScrollSnapSlider
        ref="slider"
        :items="lots"
        slider-class="flex items-start lg:gap-x-3 recomended-swiper"
        :get-item-key="(lot) => lot.id"
      >
        <template #default="{ item: lot, index }">
          <div class="overflow-hidden relative flex justify-center items-start h-auto pl-5 lg:p-0 w-40 lg:w-56">
            <Card
              :lot="lot"
              :page-name="pageName"
              :page-type="pageType"
              :source-block-type="'OTHER_PRODUCTS_FROM_OWNER'"
              :show-insurance-text="showInsuranceText(index)"
            />
          </div>
        </template>
      </ScrollSnapSlider>
    </div>
  </div>
</template>

<script setup>
import Card from '~/components/lots/display_type/card.vue'
import ScrollSnapSlider from '~/components/shared/scroll_snap_slider.vue'

const props = defineProps({
  lots: {
    type: Array,
    default: () => [],
  },
  pageName: {
    type: String,
    default: '',
  },
  pageType: {
    type: String,
    default: '',
  },
})

const slider = ref(null)

const showInsuranceText = index => {
  const firstInsuranceIndex = props.lots.findIndex(item => item?.category?.insurance)
  return firstInsuranceIndex === index
}
</script>

<style lang="sass" scoped>
  :deep(.scroll-snap-slide)
    @apply w-40 lg:w-56
</style>
